import { render, staticRenderFns } from "./Edit.vue?vue&type=template&id=0e5b192b&"
import script from "@/controllers/admin/instructions/Edit?v=2.0?vue&type=script&lang=ts&"
export * from "@/controllers/admin/instructions/Edit?v=2.0?vue&type=script&lang=ts&"
import style0 from "@/assets/css/backend.css?v=2.2?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports